import React from 'react'
import Button from '@material-ui/core/Button'
import {useTranslation} from "react-i18next";

const ClientUserInfoActions = (props) => {
  const {t} = useTranslation();

  const handleDelete = () => {
    props.onHandleDelete();
  }

  if (props.user && props.user.status !== 'DELETED') {
    return <Button onClick={handleDelete}
                     variant="contained"
                     color="primary">{t('user_info.delete_action')}</Button>
  } else {
    return <></>
  }
}

export default ClientUserInfoActions
